import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "horizontal-wizard-wrapper vertical-options vertical-variations" }
const _hoisted_2 = { class: "row g-3" }
const _hoisted_3 = { class: "col-xl-9" }
const _hoisted_4 = {
  class: "tab-content dark-field",
  id: "vertical-n-wizard-tabContent"
}
const _hoisted_5 = {
  class: "tab-pane fade",
  id: "successful-n-wizard",
  role: "tabpanel",
  "aria-labelledby": "successful-n-wizard-tab"
}

import { reactive, defineAsyncComponent } from "vue";
import * as bootstrap from "bootstrap";


export default /*@__PURE__*/_defineComponent({
  __name: 'projectCreation',
  setup(__props) {

const Card1 = defineAsyncComponent(
  () => import("@/components/commen/card/cardData1.vue")
);
const basicInfo = defineAsyncComponent(
  () => import("@/components/theme/admin/projects/basicInfo.vue")
);
const moduleInfo = defineAsyncComponent(
  () => import("@/components/theme/admin/projects/moduleInfo.vue")
);
const featureinfo = defineAsyncComponent(
  () => import("@/components/theme/admin/projects/laneInfo.vue")
);
const finalStep = defineAsyncComponent(
  () => import("@/components/theme/admin/projects/finalStep.vue")
);
const usersManagement = defineAsyncComponent(
  () => import("@/components/theme/admin/projects/teamPlanning.vue")
);

// ─── Shared payload restructured to match user's requested sample ───────────
const workspacePayload = reactive({
  company_id: "693957131e9c3a2e76c806ac", // Dummy for now
  variables: {
    title: "",
    "workspace-type": "",
    "workspace-industries": [] as string[],
    roles: [] as any[],
  },
  logo: null as string | null,
  lanes: [] as any[],
  description: "", // Hidden in final payload if not needed, but kept for review
});

// ─── Tab switching helper ────────────────────────────────────────────────────
function switchToTab(identifier: string | number): boolean {
  let tabLink: HTMLElement | null = null;

  if (typeof identifier === "string") {
    tabLink = document.querySelector(`#${identifier}`) as HTMLElement;
  } else if (typeof identifier === "number") {
    const tabLinks = document.querySelectorAll(
      "#vertical-n-wizard-tab .nav-link"
    );
    tabLink = tabLinks[identifier] as HTMLElement;
  }

  if (tabLink && typeof bootstrap !== "undefined" && bootstrap.Tab) {
    try {
      const tab = new bootstrap.Tab(tabLink);
      tab.show();
      return true;
    } catch (error) {
      console.error("Failed to switch tab:", error);
      return false;
    }
  } else {
    console.error(
      `Tab not found or Bootstrap Tab API unavailable. Identifier: ${identifier}`
    );
    return false;
  }
}

// ─── Step handlers ───────────────────────────────────────────────────────────
function handleStep1(data: { description: string }) {
  workspacePayload.description = data.description;
  switchToTab("bank-n-wizard-tab");
}

function handleStep2(data: {
  logo: string | null;
  workspaceName: string;
  workspaceType: string;
  industryId: string;
}) {
  workspacePayload.logo = data.logo;
  workspacePayload.variables.title = data.workspaceName;
  workspacePayload.variables["workspace-type"] = data.workspaceType;
  // Wrap single industry in array as per required format
  workspacePayload.variables["workspace-industries"] = data.industryId ? [data.industryId] : [];
  switchToTab("inquiry-n-wizard-tab");
}

function handleStep3(data: { lanes: any[] }) {
  workspacePayload.lanes = data.lanes;
  switchToTab("user-managment-n-wizard-tab");
}

function handleStep4(data: { teams: any[] }) {
  workspacePayload.variables.roles = data.teams;
  switchToTab("successful-n-wizard-tab");
}

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, { title: "pageTitle" }),
    _createVNode(_unref(Card1), {
      colClass: "col-sm-12",
      cardhaderClass: "pb-0 title-header",
      title: "Create Workspace"
    }, {
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-xl-3 main-horizontal-header" }, [
              _createElementVNode("div", {
                class: "nav nav-pills horizontal-options",
                id: "vertical-n-wizard-tab",
                role: "tablist",
                "aria-orientation": "vertical"
              }, [
                _createElementVNode("a", {
                  class: "nav-link active",
                  id: "wizard-n-info-tab",
                  "data-bs-toggle": "pill",
                  href: "#wizard-n-info",
                  role: "tab",
                  "aria-controls": "wizard-n-info",
                  "aria-selected": "true"
                }, [
                  _createElementVNode("div", { class: "horizontal-wizard" }, [
                    _createElementVNode("div", { class: "stroke-icon-wizard" }, [
                      _createElementVNode("span", null, "1")
                    ]),
                    _createElementVNode("div", { class: "horizontal-wizard-content" }, [
                      _createElementVNode("h3", null, "Get Started")
                    ])
                  ])
                ]),
                _createElementVNode("a", {
                  class: "nav-link",
                  id: "bank-n-wizard-tab",
                  "data-bs-toggle": "pill",
                  href: "#bank-n-wizard",
                  role: "tab",
                  "aria-controls": "bank-n-wizard",
                  "aria-selected": "false"
                }, [
                  _createElementVNode("div", { class: "horizontal-wizard" }, [
                    _createElementVNode("div", { class: "stroke-icon-wizard" }, [
                      _createElementVNode("span", null, "2")
                    ]),
                    _createElementVNode("div", { class: "horizontal-wizard-content" }, [
                      _createElementVNode("h3", null, "Workspace Setup")
                    ])
                  ])
                ]),
                _createElementVNode("a", {
                  class: "nav-link",
                  id: "inquiry-n-wizard-tab",
                  "data-bs-toggle": "pill",
                  href: "#inquiry-n-wizard",
                  role: "tab",
                  "aria-controls": "inquiry-n-wizard",
                  "aria-selected": "false"
                }, [
                  _createElementVNode("div", { class: "horizontal-wizard" }, [
                    _createElementVNode("div", { class: "stroke-icon-wizard" }, [
                      _createElementVNode("span", null, "3")
                    ]),
                    _createElementVNode("div", { class: "horizontal-wizard-content" }, [
                      _createElementVNode("h3", null, "Define Lanes")
                    ])
                  ])
                ]),
                _createElementVNode("a", {
                  class: "nav-link",
                  id: "user-managment-n-wizard-tab",
                  "data-bs-toggle": "pill",
                  href: "#user-managment-n-wizard",
                  role: "tab",
                  "aria-controls": "user-managment-n-wizard",
                  "aria-selected": "false"
                }, [
                  _createElementVNode("div", { class: "horizontal-wizard" }, [
                    _createElementVNode("div", { class: "stroke-icon-wizard" }, [
                      _createElementVNode("span", null, "4")
                    ]),
                    _createElementVNode("div", { class: "horizontal-wizard-content" }, [
                      _createElementVNode("h3", null, "Team Planning")
                    ])
                  ])
                ]),
                _createElementVNode("a", {
                  class: "nav-link",
                  id: "successful-n-wizard-tab",
                  "data-bs-toggle": "pill",
                  href: "#successful-n-wizard",
                  role: "tab",
                  "aria-controls": "successful-n-wizard",
                  "aria-selected": "false"
                }, [
                  _createElementVNode("div", { class: "horizontal-wizard" }, [
                    _createElementVNode("div", { class: "stroke-icon-wizard" }, [
                      _createElementVNode("span", null, "5")
                    ]),
                    _createElementVNode("div", { class: "horizontal-wizard-content" }, [
                      _createElementVNode("h3", null, "Completed")
                    ])
                  ])
                ])
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(basicInfo), { onContinue: handleStep1 }),
                _createVNode(_unref(moduleInfo), { onContinue: handleStep2 }),
                _createVNode(_unref(featureinfo), { onContinue: handleStep3 }),
                _createVNode(_unref(usersManagement), { onContinue: handleStep4 }),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_unref(finalStep), { payload: workspacePayload }, null, 8, ["payload"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})